// src/components/messaging/FloatingMessaging/ConfirmationModal.jsx
import React from 'react'
import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
  CButton,
  CSpinner,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { useTranslation } from 'react-i18next'

const ConfirmationModal = ({
  visible,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  confirmButtonClass = 'btn-primary',
  loading = false,
  icon = null,
  customActions = null,
  hideDefaultActions = false,
}) => {
  const { t } = useTranslation()
  // Libellés neutres par défaut (common) ; un appelant métier peut toujours
  // passer son propre confirmText/cancelText contextuel.
  const confirmLabel = confirmText || t('common:confirm')
  const cancelLabel = cancelText || t('common:cancel')

  const handleConfirm = () => {
    if (loading) return
    onConfirm()
  }

  return (
    <CModal visible={visible} onClose={onClose} className="confirmation-modal" backdrop="static">
      <CModalHeader className="confirmation-modal-header">
        <CModalTitle className="confirmation-modal-title">
          {icon && (
            <div className="confirmation-icon">
              <CIcon icon={icon} />
            </div>
          )}
          {title}
        </CModalTitle>
      </CModalHeader>

      <CModalBody className="confirmation-modal-body">
        <div className="confirmation-message">{message}</div>
      </CModalBody>

      {!hideDefaultActions && (
        <CModalFooter className="confirmation-modal-footer">
          <CButton color="secondary" variant="outline" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </CButton>
          <CButton
            color={confirmButtonClass.replace('btn-', '')}
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading && <CSpinner size="sm" className="me-1" />}
            {confirmLabel}
          </CButton>
        </CModalFooter>
      )}

      {customActions && (
        <CModalFooter className="confirmation-modal-footer">{customActions}</CModalFooter>
      )}
    </CModal>
  )
}

export default ConfirmationModal
